import { Grid } from '@mui/material';
import { FieldArray, FormikErrors } from 'formik';
import React from 'react';

import {
	ValuemappingProfileFormShape,
	VALUE_FROM_NOT_REQUIRED_METHODS,
} from '@Types/valuemappingForm.types';
import { Mapping } from '@Types/valuemappingManager.types';
import AddRemoveAdornment from './AddRemoveAdornment/AddRemoveAdornmentSwitch';
import { ValuemappingMappingRow } from './ValuemappingMappingRow';

interface ValuemappingMappingRowListProps {
	methodOptions: string[];
	disabled?: boolean;
	values: ValuemappingProfileFormShape['mappings'];
	errors: Partial<FormikErrors<ValuemappingProfileFormShape>>;
}

const DEFAULT_ROW_VALUES: Mapping = {
	order: 0,
	from: null,
	method: 'Last Known Value',
	to: '',
};

export const ValuemappingMappingRowList: React.FC<
	ValuemappingMappingRowListProps
> = ({
	methodOptions,
	values: mappingRows,
	disabled,
	errors,
}: ValuemappingMappingRowListProps) => {
	return (
		<Grid direction="column" spacing={2} container>
			{/*
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				@ts-ignore */}
			<FieldArray
				name="mappings"
				render={({ handleInsert, handleRemove }) =>
					mappingRows.map((mappingRow, idx) => (
						<ValuemappingMappingRow
							key={`mapping-field-key-${idx}`}
							index={idx}
							methodOptions={methodOptions}
							endAdornment={
								<AddRemoveAdornment
									single={mappingRows.length === 1}
									first={idx === 0}
									last={idx === mappingRows.length - 1}
									onClickAdd={handleInsert(idx + 1, {
										...DEFAULT_ROW_VALUES,
										order: idx + 1,
									})}
									onClickRemove={handleRemove(idx)}
								/>
							}
							disabled={disabled}
							disabledFields={{
								method: idx !== 0 && !mappingRow.from,
								to: VALUE_FROM_NOT_REQUIRED_METHODS.includes(
									mappingRow.method,
								),
							}}
							errors={errors}
						/>
					))
				}
			/>
		</Grid>
	);
};

export default ValuemappingMappingRowList;
